import { render, staticRenderFns } from "./AdItemDesignTypeHandler.vue?vue&type=template&id=6193c207&scoped=true&"
import script from "./AdItemDesignTypeHandler.vue?vue&type=script&lang=ts&"
export * from "./AdItemDesignTypeHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6193c207",
  null
  
)

export default component.exports